<script>
	let { label, items, currentPath } = $props();
	let open = $state(false);
	let hovering = $state(false);
	let container;
	let closeTimer;

	function openMenu() {
		clearTimeout(closeTimer);
		open = true;
	}

	function onEnter() {
		hovering = true;
		openMenu();
	}

	function onLeave() {
		hovering = false;
		scheduleClose();
	}

	function scheduleClose() {
		closeTimer = setTimeout(() => {
			open = false;
		}, 150);
	}

	function toggle() {
		if (hovering) return;
		if (open) {
			open = false;
		} else {
			openMenu();
		}
	}

	function handleClickOutside(event) {
		if (container && !container.contains(event.target)) {
			clearTimeout(closeTimer);
			open = false;
		}
	}

	$effect(() => {
		if (open) {
			document.addEventListener('click', handleClickOutside, true);
			return () => {
				document.removeEventListener('click', handleClickOutside, true);
				clearTimeout(closeTimer);
			};
		}
	});
</script>

<div
	class="relative"
	role="navigation"
	aria-label="{label} menu"
	bind:this={container}
	onmouseenter={onEnter}
	onmouseleave={onLeave}
>
	<button
		class="flex items-center gap-1 text-sm font-medium transition-colors {items.some(i => i.href === currentPath) ? 'text-wine' : 'text-navy hover:text-wine'}"
		onclick={toggle}
		aria-expanded={open}
	>
		{label}
		<svg class="h-3.5 w-3.5 transition-transform {open ? 'rotate-180' : ''}" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
			<path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
		</svg>
	</button>

	{#if open}
		<div
			class="absolute left-0 top-full z-50 min-w-48 rounded border border-stone-dark bg-altar-white py-1 shadow-lg"
			onmouseenter={onEnter}
			onmouseleave={onLeave}
		>
			{#each items as item}
				<a
					href={item.href}
					class="block px-4 py-2 text-sm transition-colors {item.href === currentPath ? 'text-wine font-medium' : 'text-navy hover:bg-parchment hover:text-wine'}"
					onclick={() => open = false}
				>
					{item.label}
				</a>
			{/each}
		</div>
	{/if}
</div>
